import React from "react";
import "./InfoCard.css";

interface Props {
  children: React.ReactNode;
  className?: string;
  /**
   * Removes top padding to make space for a controls bar.
   *
   * Assumes that the first child will be a div with className="info-card-header-bar"
   * which handles layout, and within which another element can handle theme+content.
   */
  includesHeaderBar?: boolean;
  /**
   * Reduce the padding and margins around the card to tightly wrap the content.
   */
  tightWrap?: boolean;
}

function InfoCard(props: Props) {
  const { children, className, includesHeaderBar, tightWrap } = props;

  const hbClass = includesHeaderBar ? "includes-header-bar" : "";
  const tightClass = tightWrap ? "tight-wrap" : "";

  const classes = `info-card-section ${hbClass} ${tightClass} ${className || ""}`;
  return <section className={classes}>{children}</section>;
}

export default InfoCard;
